import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { NgClass } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';


@Component({
    selector: 'unite-building-status-field',
    templateUrl: './building-status-field.component.html',
    styleUrls: ['./building-status-field.component.scss'],
    imports: [MatFormField, NgClass, MatSelect, ReactiveFormsModule, MatOption, TranslateModule, MatIcon, MatTooltip]
})
export class BuildingStatusFieldComponent {

  control = input<FormControl>();
  classField = input('');

  editIcon = input(false);
  checkIcon = input(true);

  ownershipVerified = input(false);


  onEnter(event: KeyboardEvent) {
    (<HTMLInputElement>event.target).blur();
  }
}
